import { useQuery } from "@tanstack/react-query";
import { createContext, useState, useCallback } from "react";
import { authenticationService } from "../../services/authentication";
import type { CustomCognitoUser } from "../../services/authentication/types";
import { DistributorUserRole } from "../../services/backend_client";
import type { AuthenticationContextProviderProps, AuthenticationContextValue } from "./types";

export const AuthenticationContext = createContext<AuthenticationContextValue | undefined>(undefined);

export const AuthenticationContextProvider = ({ children }: AuthenticationContextProviderProps) => {
  const [user, setUser] = useState<CustomCognitoUser>();
  // TODO: It would be better to move this fields to myAccountInfo
  const [userId, setUserId] = useState<string>("");
  const [schoolId, setSchoolId] = useState<string>("");
  const [distributorId, setDistributorId] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  ///
  const [role, setRole] = useState<string>("");

  const { isLoading: isDeterminingAuthenticationStatus } = useQuery<CustomCognitoUser>(
    ["getAuthenticatedUser"],
    () => authenticationService.getAuthenticatedUser(),
    {
      retry: false,
      onSuccess: async (user) => {
        if (user === undefined) {
          return;
        }
        if (user.attributes !== undefined) {
          setUser(user);
          setUserId(user.attributes["custom:UserId"]);
          if (user.attributes["custom:Role"] === DistributorUserRole.DistributorAdmin || user.attributes["custom:Role"] === DistributorUserRole.Agent) {
            setDistributorId(user.attributes["custom:DistributorId"]);
          } else {
            setSchoolId(user.attributes["custom:SchoolId"]);
          }
          setRole(user.attributes["custom:Role"]);
          setEmail(user.attributes.email);
        } else {
          const session = await authenticationService.getCurrentSession();
          const payload = session.getIdToken().payload;
          setUser(user);
          setUserId(payload["custom:UserId"]);
          setRole(payload["custom:Role"]);
          if (payload["custom:Role"] === DistributorUserRole.DistributorAdmin || payload["custom:Role"] === DistributorUserRole.Agent) {
            setDistributorId(payload["custom:DistributorId"]);
          } else {
            setSchoolId(payload["custom:SchoolId"]);
          }
          setEmail(payload.email);
        }
      },
    },
  );
  const getJwtToken = useCallback(async () => {
    const currentSession = await authenticationService.getCurrentSession();
    const idToken = currentSession.getIdToken();
    return idToken.getJwtToken();
  }, []);

  const value = {
    isDeterminingAuthenticationStatus,
    user,
    setUser,
    getJwtToken,
    userId,
    setUserId,
    schoolId,
    setSchoolId,
    distributorId,
    setDistributorId,
    role,
    setRole,
    email,
    setEmail,
  };

  return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
};
